import React from 'react';

const RecentDealSkeleton = () => {

  return (
      <div className='recent-deals-wrapper-skeleton'>
        <h2 className='title'/>
        <div className='deals'>
          <a className='recent-deal'>
            <div className="pic"/>
            <div className="sold"/>
            <div className="price-n-bids">
              <span className="price"/>
              <span className="bids"/>
            </div>
          </a>
          <a className='recent-deal'>
            <div className="pic"/>
            <div className="sold"/>
            <div className="price-n-bids">
              <span className="price"/>
              <span className="bids"/>
            </div>
          </a>
        </div>
        <div className='explore-market-place'/>
      </div>
  );
};

export default RecentDealSkeleton;